import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import compose from 'recompose/compose';
import connect from "react-redux/es/connect/connect";
import Grid from "@material-ui/core/Grid/Grid";
import Paper from "@material-ui/core/Paper/Paper";
import MaterialTable from "material-table";


import AddBox from '@material-ui/icons/AddBox';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import FiltersSection from "../../Filters/FiltersSection";
import {Typography} from "@material-ui/core";
import {getRoitreadCycleHourUsageStatistics, getRoitreadCycles} from "../../../actions/roitreadCycleActions";
import RoitreadCycleDistributionOnHourStackedChart from "./RoitreadCycleDistributionOnHourStackedChart";
import RoitreadKPIs from "./RoitreadKPIs";
import TireSizesParetoChart from "../../Producao/TiresDashboard/TireSizesParetoChart";
import RoitreadExtrusionPerTireSizesParetoChart from "./RoitreadExtrusionPerTireSizesParetoChart";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import {getAutoclaves} from "../../../actions/autoclaveActions";
import {convertSecondsToMinutesSecondsFormat} from "../../../common/Util";
import OSESeriesDHChart from "../../../components/OSESeriesDHChart";

const tableIcons = {
    Add: AddBox,
    Check: Check,
    Clear: Clear,
    Delete: DeleteOutline,
    DetailPanel: ChevronRight,
    Edit: Edit,
    Export: SaveAlt,
    Filter: FilterList,
    FirstPage: FirstPage,
    LastPage: LastPage,
    NextPage: ChevronRight,
    PreviousPage: ChevronLeft,
    ResetSearch: Clear,
    Search: Search,
    SortArrow: ArrowUpward,
    ThirdStateCheck: Remove,
    ViewColumn: ViewColumn
};


const styles = theme => ({

    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
    dashboardCardSection: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1) * 8
    },
    dense: {
        marginTop: 19,
    },
    menu: {
        width: 200,
    },
    filterSection: {
        marginTop: '15px'
    },
    dashGrids: {
        marginTop: '15px'
    }
});

class RoitreadCycles extends React.Component {
    constructor(props) {
        super(props);

        this.renderContent = this.renderContent.bind(this);
    }


    componentDidMount(){
       // this.props.getRoitreadCycles();
        this.props.getRoitreadCycleHourUsageStatistics()
    }


    getColumnsMedida() {
        return [
            {
                title: 'Medida',
                field: 'descricao',
                editable: 'never',
                hidden: false
            },
            {
                title: '# Ciclos',
                field: 'numCiclos',
                editable: 'never',
                cellStyle: {
                    // backgroundColor: '#039be5',
                    // color: '#FFF',
                    justifyContent: 'flex-end',
                    alignContent: 'flex-end',
                    textAlign: 'right'

                },
                //type: 'datetime'

            },
            {
                title: '# Extrusões',
                field: 'numCiclosExtrusao',
                editable: 'never',
                cellStyle: {
                    // backgroundColor: '#039be5',
                    // color: '#FFF',
                    justifyContent: 'flex-end',
                    alignContent: 'flex-end',
                    textAlign: 'right'

                },
            },
            // {
            //     title: 'sum Tempo',
            //     field: 'sumTempoExtrusao',
            //     editable: 'never',
            //     cellStyle: {
            //         // backgroundColor: '#039be5',
            //         // color: '#FFF',
            //         justifyContent: 'flex-end',
            //         alignContent: 'flex-end',
            //         textAlign: 'right'
            //
            //     },
            //     render: d => convertSecondsToMinutesSecondsFormat((d.sumTempoExtrusao * 1).toFixed())
            // },

            {
                title: 'média Tempo Extrusão',
                field: 'avgTempoExtrusao',
                editable: 'never',
                cellStyle: {
                    // backgroundColor: '#039be5',
                    // color: '#FFF',
                    justifyContent: 'flex-end',
                    alignContent: 'flex-end',
                    textAlign: 'right'

                },
                render: d => convertSecondsToMinutesSecondsFormat( (d.avgTempoExtrusao * 1).toFixed())
            },
            {
                title: 'Consumo total',
                field: 'sumConsumo',
                editable: 'never',
                cellStyle: {
                    // backgroundColor: '#039be5',
                    // color: '#FFF',
                    justifyContent: 'flex-end',
                    alignContent: 'flex-end',
                    textAlign: 'right'

                },
                render: d => (d.sumConsumo * 1).toFixed(3).toLocaleString(navigator.language, { minimumFractionDigits: 0 })
            },
            {
                title: 'Consumo / ciclo (kg)',
                field: 'avgConsumo',
                editable: 'never',
                cellStyle: {
                    // backgroundColor: '#039be5',
                    // color: '#FFF',
                    justifyContent: 'flex-end',
                    alignContent: 'flex-end',
                    textAlign: 'right'

                },
                render: d => (d.avgConsumo * 1).toFixed(3)
            }


        ];
    }



    getColumns() {
        return [
            {
                title: 'id',
                field: 'id',
                editable: 'never',
                hidden: true
            },
            {
                title: 'Data',
                field: 'Data',
                editable: 'never',
                //type: 'datetime'
                render: d => d.Data.substring(0,10) + ' '+d.Data.substring(11,19)
            },
            {
                title: 'Ordem Produção',
                field: 'OrdemServico',
                editable: 'never'
            },
            {
                title: 'Posicao',
                field: 'Posicao',
                editable: 'never'
            },

            {
                title: 'Banda Serial',
                field: 'BandaSerialNumber',
                editable: 'never'
            },
            {
                title: 'Extrusao - Tempo',
                field: 'ExtrusoraTempoCiclo',
                editable: 'never'
            },
            {
                title: 'Roletadeira - Tempo',
                field: 'RoletadeiraTempoCiclo',
                editable: 'never'
            },

            {
                title: 'Tempo Espera',
                field: 'CicloTempoWait',
                editable: 'never'
            }


        ];
    }

    renderLoadingScreen() {
        const { classes } = this.props;
        return (
            <React.Fragment>
                <div align="center">
                    <CircularProgress className={classes.progress} />
                </div>
            </React.Fragment>
        )
    }

    renderContent(){
        const { classes, ciclos } = this.props;


        var result = [];


        console.log("DADOS PRA REDUZIR",ciclos.RoitreadCycleStatistics.roitreadCycleDistributionByDateAndHour);
        if (ciclos.RoitreadCycleStatistics && Array.isArray(ciclos.RoitreadCycleStatistics.roitreadCycleDistributionByDateAndHour)) {
            ciclos.RoitreadCycleStatistics.roitreadCycleDistributionByDateAndHour.reduce(function (res, value) {
                var key = value.Data + "-" + value.Hora.toString();
                //console.log(key);
                if (!res[key]) {
                 //   console.log("nao existe chave ", key)
                    res[key] = {
                        Data: value.Data, Hora: value.Hora,
                        QtdeCiclos: 0, //value.QtdeCiclos,
                        Coluna1: 0,
                        Coluna2: 0,
                        Coluna3: 0,
                        TempoTotal: 0, //value.TempoTotal,
                        PercTempo: 0   //value.PercTempo
                    };
                    result.push(res[key])
                }
             //   console.log("somando a key ", key, value.QtdeCiclos,  res[key]);
                switch (value.posicao) {
                    case 1:
                        res[key].Coluna1 += value.QtdeCiclos;
                        break;
                    case 2:
                        res[key].Coluna2 += value.QtdeCiclos;
                        break;
                    case 3:
                        res[key].Coluna3 += value.QtdeCiclos;
                        break;
                }
                res[key].QtdeCiclos += value.QtdeCiclos;
                res[key].TempoTotal += value.TempoTotal;
                res[key].PercTempo += value.TempoTotal / 3600 * 100;
                return res;
            }, {});
        }

        console.log("result reduce",result);


        return (
            <Grid container >

                <Grid item xs={12} md={12} lg={12} >
                    <RoitreadKPIs series={ciclos.RoitreadCycleStatistics.hourUsageTotals} seriesPerType={ciclos.RoitreadCycleStatistics.hourUsageTotals} filter={this.props.filter} />
                </Grid>

                <Grid item xs={12} md={12} lg={12} className={classes.dashGrids}>
                    <Paper>
                        <Grid item xs={12} className={classes.marginBottom}>
                            <OSESeriesDHChart isLoading={this.props.isLoading} series={result}
                                              filter={this.props.filter} title="RITMO POR HORA"/>
                        </Grid>
                    </Paper>
                </Grid>

                {
                    ciclos.RoitreadCycleStatistics.hourUsageTotals.map( (rp,ix) => {
                         const ddth = ciclos.RoitreadCycleStatistics.roitreadCycleDistributionByDateAndHour.filter( dh => dh.posicao === rp.posicao);
                         return (
                             <Grid key={ix} item xs={12} md={12} lg={12} className={classes.dashGrids}>
                                 <Paper>
                                     <RoitreadCycleDistributionOnHourStackedChart
                                         series={ddth}
                                         filter={this.props.filter}
                                         coluna={rp.posicao}
                                     />

                                 </Paper>
                             </Grid>
                         )

                    })
                }




                {/*}*/}

                {/*<Grid item xs={12} className={classes.dashGrids}>*/}
                {/*    <RoitreadExtrusionPerTireSizesParetoChart series={ciclos.RoitreadCycleStatistics.ExtrusionComsuptionPerTireSize} filter={this.props.filter} />*/}
                {/*</Grid>*/}

                <Grid item xs={12} md={12} lg={12} className={classes.dashGrids}>
                    <Paper>
                        <MaterialTable
                            icons={tableIcons}
                            title="Roitread - por Medida"

                            columns={this.getColumnsMedida()}
                            data={ciclos.RoitreadCycleStatistics.roitreadCiclosPorMedida}
                            options={{
                                filtering: true,
                                pageSize: 10,
                                pageSizeOptions: [5,10,20,50,100]
                            }}
                        />
                    </Paper>
                </Grid>
            </Grid>
        )
    }


    render() {
        const { classes, ciclos } = this.props;
        const { isFetchingRoitreadCycles } = ciclos;

        console.log("STORE", this.props.store);

        return (
           <React.Fragment>
                <Grid container direction="column" className={classes.filterSection}>
                    <Grid item xs={12}>
                        <FiltersSection showPeriod={true} showBeforePeriod={false} showBenchPeriod={false} />
                    </Grid>
                </Grid>
               <Grid item  xs={12} sm={12} lg={12} xl={12}>
                   <Typography variant="h4" align="center" className={classes.sectionTitle}>
                       APLICACAO BANDA - PRODUÇÃO
                   </Typography>
               </Grid>

                { isFetchingRoitreadCycles ? this.renderLoadingScreen() : this.renderContent() }

                {/*<Typography variant="title" align="center" className={classes.sectionTitle}>*/}
                    {/*Roitread - ciclos*/}
                {/*</Typography>*/}

           </React.Fragment>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        store: state,
        ciclos: state.roitreadCycles,
        filter: state.filter,
    }
}

// export default compose(
//     withStyles(styles, {withTheme: true}),
//     connect(mapStateToProps, {getRoitreadCycles, getRoitreadCycleHourUsageStatistics})
// )
export default connect(mapStateToProps, { getRoitreadCycles, getRoitreadCycleHourUsageStatistics })(withStyles(styles, {withTheme: true})(RoitreadCycles))
